/**
 * 🗑️ DELETE ELEMENT MODAL
 * 
 * Einfaches Modal für Element-Deletion
 * - Gleicher Style wie delete_modal (minimalistisch)
 * - Portal Rendering damit es ganz nach vorne kommt
 * - Verhindert versehentliches Löschen von Content
 */

import React from 'react';
import ReactDOM from 'react-dom';
import './DeleteElementModal.css';

const DeleteElementModal = ({ isOpen, onClose, onConfirm, elementType = 'element' }) => {
  if (!isOpen) return null;

  // Element-Type Labels für bessere UX
  const elementLabels = {
    'text': 'text',
    'button': 'button',
    'image': 'image',
    'divider': 'divider',
    'video': 'video',
    'gallery': 'gallery',
    'qa': 'Q&A',
    'grid': 'grid',
    'element': 'element' // Fallback
  };

  const label = elementLabels[elementType] || 'element';

  return ReactDOM.createPortal(
    <div className="delete_modal">
      <p>Really want to delete this {label}?</p>
      <button onClick={onConfirm}>Yes</button>
      <button onClick={onClose}>No</button>
    </div>,
    document.body
  );
};

export default DeleteElementModal;

